import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpline-details',
  templateUrl: './helpline-details.component.html',
  styleUrls: ['./helpline-details.component.scss']
})
export class HelplineDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
